<template>
    <section >
        <!-- <div class="text-center my-3">
  <b-button v-b-tooltip.hover title="Tooltip content">Hover Me</b-button>
</div> -->
        <table class="table">
            <tbody>
                <tr class="bg-primary">
                    <td>
                        <h5 class="text-white text-left font-weight-bold" style="font-family: kia_bold">
                            <b >Total compra</b>
                        </h5>
                    </td>
                    <td>
                        <h5 class="text-white label-table text-right font-weight-bold" style="font-family: kia_bold">
                            <b>$ {{totalCompra | puntos}}</b>
                        </h5>
                    </td>
                </tr>

                <tr>
                    <td>
                        

                        <h6 class="text-dark label-table text-left">
                            <b>Precio normal más beneficios</b>
                        </h6>
                    </td>
                    <td>
                        <h6 class="text-dark label-table text-right">
                            <b>$ {{precioNomal | puntos }}</b>
                        </h6>
                    </td>
                </tr>

                <tr class="divisor bg-secondary">
                    <td>
                        <h6 class=" fw-bold text-bold text-dark label-table text-left ">
                            <b class="fw-bold">Ahorro</b>
                        </h6>
                    </td>
                    <td>
                        <h6 class="fw-bold text-bold text-dark label-table text-right">
                            <b>$ {{ahorro | puntos}}</b>
                        </h6>
                    </td>
                </tr>
                
                <tr class="divisor">
                    <td>
                        <h6 class="text-dark label-table text-left ">
                            <b>% Ahorro</b>
                        </h6>
                    </td>
                    <td>
                        <h6 class="text-dark label-table text-right">
                            <b>{{porcentajeAhorro | puntos }}%</b>
                        </h6>
                    </td>
                </tr>
                
                <tr class="bg-primary">
                    <td>
                        <h5 class="text-white text-left font-weight-bold" style="font-family: kia_bold">
                            <b >Total a pagar</b>
                        </h5>
                    </td>
                    <td>
                        <h5 class="text-white label-table text-right font-weight-bold" style="font-family: kia_bold">
                            <b>$ {{total | puntos}}</b>
                        </h5>
                    </td>
                </tr>
            </tbody>
        </table>
    </section>
</template>

<script>
import constantes from '../../constantes';

export default{
    name:"tablaTotales",

    props: ['sumaValue','subTotal', 'ahorro', 'precioNomal', 'porcentajeAhorro', 'contador', 'totalCompra', 'total'],

    filters: {
        puntos: (numero) => constantes.funciones.puntoMilesDecimal(numero),
    },


}
</script>


